import WindowCommunication from '@/utils/windowCommunication'
import { onMounted, onUnmounted, ref } from 'vue'

/**
 * 打开新建门店页面
 */
export const openAddStorePage = () => {
  const url = '/companyNew/company/storeManage/add?scene=1'
  const newWindow = window.open(url, '_blank')
  const currentWindow = window

  if (newWindow) {
    newWindow.addEventListener('beforeunload', () => {
      setTimeout(() => {
        currentWindow.focus()
      }, 100)
    })
  }

  return newWindow
}

/**
 * 监听门店新建成功事件的 composable
 * @param {Function} onStoreAdded - 门店新建成功的回调函数，接收新建门店的 ID
 * @returns {Object} - { isListening: Ref<boolean> }
 */
export const useStoreAddedListener = (onStoreAdded) => {
  const communication = ref(null)
  const isListening = ref(false)

  const handleStoreAdded = (data) => {
    if (onStoreAdded) {
      onStoreAdded(data)
    }
  }

  onMounted(() => {
    communication.value = new WindowCommunication('lease_store_added', {
      timeout: 2000,
    })
    communication.value.on('lease_store_added', handleStoreAdded)
    isListening.value = true
  })

  onUnmounted(() => {
    if (communication.value) {
      communication.value.off('lease_store_added', handleStoreAdded)
      communication.value.destroy()
      isListening.value = false
    }
  })

  return {
    isListening,
  }
}
